export const VideoObjectId = 'Video';

export enum VideoObjectAttributes {
  TITLE = 'title',
  TAGS = 'tags',
  BLOB = 'blob',
  ALT_TEXT = 'altText',
  VISIBLE_IN_SEARCH = 'visibleInSearch',
}
